export function isWebSocketActivated() {
	return process.env.FEATURE_WEBSOCKET_ACTIVATED === 'true';
}

export function isToastNotificationsActivated() {
	return process.env.FEATURE_TOAST_NOTIFICATIONS_ACTIVATED === 'true';
}

export function isStarknetActivated() {
	return process.env.FEATURE_STARKNET_ACTIVATED === 'true';
}

export function isNewsMasterActivated() {
	return process.env.FEATURE_NEWS_MASTER_ACTIVATED === 'true';
}

export function isAuthCliActivated() {
	return process.env.FEATURE_AUTH_CLI_ACTIVATED === 'true';
}
